import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
/* import useExporter from "../../hooks/useExporter"; */
import { useNavigate, useLocation, useParams } from "react-router-dom";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import {
  getBillingHistoryByAgreement,
  createHistoryAndBilling,
  deleteHistoryBilling,
} from "../../api/BillingGroups";
import { useAuth } from "../../providers/AuthContext";
import InputField from "../../components/InputField";
import toast from "react-hot-toast";
import ConfirmationModal from "../../components/ConfirmationModal";
import LoadingTablePage from "../LoadingTablePage"; //src/pages/LoadingTablePage.js
import Breadcrumbs from "../../components/Breadcrumbs";
import TableView from "../../components/TableView";

const BillingHistoryPage = () => {
  /* const { handleExport } = useExporter(); */
  const { getAccessToken } = useAuth();
  const { agreementPublicId } = useParams();
  const [selectedRows, setSelectedRows] = useState([]);
  const [historyBilling, setHistoryBilling] = useState([]);
  const [filteredHistoryBilling, setFilteredHistoryBilling] = useState([]);
  const [historyBillingLoaded, setHistoryBillingLoaded] = useState(false);
  const [subject, setSubject] = useState("");
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() == 0 ? 12 : new Date().getMonth() + 1);

  useEffect(() => {
    handleGetHistoryBilling(); // Initial fetch
  }, []);

  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    setYears([currentYear - 1, currentYear, currentYear + 1]);
    setSelectedYear(currentYear);
  }, []);

  /*   const query = new URLSearchParams(location.search);
  const [activeTab, setActiveTab] = useState(
    query.get("tab") ? query.get("tab") : "historyList"
  );

  useEffect(() => {
    const tab = query.get("tab");
    if (tab) {
      setActiveTab(tab);
    }
  }, [location.search]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    query.set("tab", activeTab);
    navigate(`${location.pathname}?${query.toString()}`, { replace: true });
  }, [activeTab, location.pathname, navigate]); */

  const handleGetHistoryBilling = async () => {
    try {
      const accessToken = await getAccessToken();
      const newHistoryBilling = await getBillingHistoryByAgreement(
        agreementPublicId,
        accessToken
      );
      console.log("API response (raw):", newHistoryBilling);

      newHistoryBilling.forEach((item) => {
        item.billingHistoryId = Math.floor(Math.random() * 1000000);
        item.fromDate = item.fromDate?.split("T")[0];
        item.toDate = item.toDate?.split("T")[0];
      });

      setHistoryBilling(newHistoryBilling);
      setFilteredHistoryBilling(newHistoryBilling);
      setHistoryBillingLoaded(true);

      console.log("Fetched billing history:", newHistoryBilling);
    } catch (error) {
      console.error(error);
      setHistoryBillingLoaded(true);
    }
  };

  const handleDeleteHistoryBilling = async (historyBillingPublicId) => {
    const toastId = toast.loading("Deleting history...");
    try {
      const accessToken = await getAccessToken();
      await deleteHistoryBilling(historyBillingPublicId, accessToken);
      handleGetHistoryBilling();

      toast.success("History deleted", {
        id: toastId,
        iconTheme: {
          primary: "#4CAF50",
          secondary: "#DFF2BF",
        },
      });
    } catch (error) {
      toast.error("Failed to delete history", { id: toastId });
      console.error(error);
    }
  };

  console.log(selectedMonth)

  const handleCreateBillingHistory = async () => {
    const trimmedSubject = subject.trim();
    if (!trimmedSubject) {
      toast.error("Subject is required");
      return;
    }

    const toastId = toast.loading("Creating billing history...");

    try {
      setSubject("");
      const now = new Date();

      const body = {
        agreementPublicId: agreementPublicId,
        year: Number(selectedMonth) == 12 ? Number(selectedYear) - 1 : Number(selectedYear),
        month: Number(selectedMonth),
        subject: trimmedSubject,
      };


      const accessToken = await getAccessToken();

      await createHistoryAndBilling(accessToken, body);
      await handleGetHistoryBilling();

      toast.success("Billing history created successfully", {
        iconTheme: {
          primary: "#4CAF50",
          secondary: "#DFF2BF",
        },
        id: toastId,
      });

      setSubject("");
    } catch (error) {
      console.error("Failed to create:", error);
      toast.error("Failed to create history and billing", {
        id: toastId,
      });
    }
  };

  console.log("BILLING HISTORY:", filteredHistoryBilling);

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="page-content">
            <Breadcrumbs />
            <div className="flex flex-row items-center pb-4">
              <h2 className="">Billing history</h2>
            </div>

            <div className="rounded-md shadow-md border w-full p-4">
              <div className="flex mb-2 gap-4 justify-between">
                <button className="btn-outline-primary-small hidden"></button>
                <div className="flex">
                  <button className="btn-outline-primary icon hidden">
                    Filter
                  </button>
                </div>
                <div className="flex items-center gap-4">
                  <div className="pt-2">
                    <InputField
                      placeholder="Subject"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                  </div>
                  <select
                    id="month-select"
                    name="month"
                    className={"input-default mt-4"}
                    value={selectedMonth}
                    onChange={(e) => {setSelectedMonth(Number(e.target.value))}}
                  >
                    <option value={12}>January</option>
                    <option value={1}>February</option>
                    <option value={2}>March</option>
                    <option value={3}>April</option>
                    <option value={4}>May</option>
                    <option value={5}>June</option>
                    <option value={6}>July</option>
                    <option value={7}>August</option>
                    <option value={8}>September</option>
                    <option value={9}>October</option>
                    <option value={10}>November</option>
                    <option value={11}>December</option>
                  </select>
                  <select
                    id="year-select"
                    name="year"
                    className={"input-default mt-4"}
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                  >
                    {years.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                  <button
                    onClick={handleCreateBillingHistory}
                    className="btn-primary mt-5"
                  >
                    <FontAwesomeIcon icon={faPlus} className="mr-2 text-lg" />
                    Create billing history
                  </button>
                </div>
              </div>

              <TableView
                data={filteredHistoryBilling}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                noCheckbox={true}
                noDelete={false}
                noEdit={true}
                columns={[
                  { key: "createdDateTimeUTC", label: "Created date" },
                  { key: "fromDate", label: "From date" },
                  { key: "toDate", label: "To date" },
                  { key: "billingGroupName", label: "Billing group name" },
                  { key: "total", label: "Total price" },
                  { key: "historyPublicId", label: "Billing history ID" },
                ]}
                primaryKey="historyPublicId"
                basePath={`/history-billing`}
                handleDelete={handleDeleteHistoryBilling}
              />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default BillingHistoryPage;
